const Cancel = () => {

    return(
     <div style={{margin: "30px 7%"}}>
        <p>キャンセルされました。</p>
     </div>   
    ) 
 }
 
 export default Cancel;